import { ButtonHTMLAttributes, MouseEvent, ReactNode } from "react";
import { IToolsMode } from "../../../@types/GoogleMaps/ToolsMode";
import { useGoogleMaps } from "../../../hooks/useGoogleMaps";
import "./styles.css";

interface ToolOptionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme: "normal" | "success";
  noSelectable?: boolean;
  defaultMode: IToolsMode;
  children: ReactNode;
  title?: string;
  visibleLabel?: string;
  strokeIcon?: boolean;
  active?: boolean;
}

export function ToolOption({
  noSelectable = false,
  defaultMode,
  children,
  theme,
  title,
  visibleLabel,
  strokeIcon = false,
  active = false,
  ...rest
}: ToolOptionProps) {
  const { toolMode, setToolMode } = useGoogleMaps();

  function handleOnclick(event: MouseEvent<HTMLButtonElement>) {
    !noSelectable && setToolMode(defaultMode);
    rest.onClick && rest.onClick(event);
  }

  return (
    <button
      {...rest}
      className={`
        toolMode__option toolMode__option-${theme} ${toolMode === defaultMode && !noSelectable ? "isselected" : ""
        } ${visibleLabel ? "toolMode__option--with-label" : ""} ${strokeIcon ? "toolMode__option--stroke-icon" : ""} ${active ? "toolMode__option--active" : ""}
      `}
      onClick={handleOnclick}
      type="button"
    >
      {children}
      {visibleLabel && <span className="toolMode__option-label">{visibleLabel}</span>}
      <span className="tooltiptext">{title}</span>
    </button>
  );
}
